import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { createAction } from '../../interfaces';
import * as definitions from '../../definitions/serviceCustomer';
import serviceCustomers from '../../services/serviceCustomer';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var serviceCustomerActionCreators = {
  getServiceCustomerRequest: function getServiceCustomerRequest() {
    return createAction(definitions.GET_SERVICE_CUSTOMER_REQUEST);
  },
  getServiceCustomerSuccess: function getServiceCustomerSuccess(userServiceCustomers) {
    return createAction(definitions.GET_SERVICE_CUSTOMER_SUCCESS, userServiceCustomers);
  },
  getServiceCustomerFail: function getServiceCustomerFail(error) {
    return createAction(definitions.GET_SERVICE_CUSTOMER_FAIL, error);
  },
  clearServiceCustomerErrorsAction: function clearServiceCustomerErrorsAction() {
    return createAction(definitions.CLEAR_SERVICE_CUSTOMER_ERRORS);
  },
  setServiceCustomerInfoAction: function setServiceCustomerInfoAction(info) {
    return createAction(definitions.SET_SERVICE_CUSTOMER_INFO, info);
  },
  clearServiceCustomerInfoAction: function clearServiceCustomerInfoAction() {
    return createAction(definitions.CLEAR_SERVICE_CUSTOMER_INFO);
  },
  getServiceCustomersByUserIdAndServiceIdRequest: function getServiceCustomersByUserIdAndServiceIdRequest() {
    return createAction(definitions.GET_SERVICE_CUSTOMER_BY_USERID_AND_SERVICEID_REQUEST);
  },
  getServiceCustomersByUserIdAndServiceIdSuccess: function getServiceCustomersByUserIdAndServiceIdSuccess(userServiceCustomers) {
    return createAction(definitions.GET_SERVICE_CUSTOMER_BY_USERID_AND_SERVICEID_SUCCESS, userServiceCustomers);
  },
  getServiceCustomersByUserIdAndServiceIdFail: function getServiceCustomersByUserIdAndServiceIdFail(error) {
    return createAction(definitions.GET_SERVICE_CUSTOMER_BY_USERID_AND_SERVICEID_FAIL, error);
  }
};
export var getServiceCustomersById = function getServiceCustomersById(id) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var getServiceCustomerRequest, getServiceCustomerSuccess, getServiceCustomerFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getServiceCustomerRequest = serviceCustomerActionCreators.getServiceCustomerRequest, getServiceCustomerSuccess = serviceCustomerActionCreators.getServiceCustomerSuccess, getServiceCustomerFail = serviceCustomerActionCreators.getServiceCustomerFail;
              dispatch(getServiceCustomerRequest());
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                serviceCustomers.getServiceCustomersById(id).then(function (userServiceCustomers) {
                  dispatch(getServiceCustomerSuccess(userServiceCustomers));
                  resolve(userServiceCustomers);
                }, function (error) {
                  var message = getErrorMessageFromErrorResponse(error);
                  dispatch(getServiceCustomerFail(message));
                  reject(message);
                  handleErrorResponse(error, dispatch);
                });
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getServiceCustomersByUserIdAndServiceId = function getServiceCustomersByUserIdAndServiceId(userId, serviceId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var getServiceCustomersByUserIdAndServiceIdRequest, getServiceCustomersByUserIdAndServiceIdSuccess, getServiceCustomersByUserIdAndServiceIdFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getServiceCustomersByUserIdAndServiceIdRequest = serviceCustomerActionCreators.getServiceCustomersByUserIdAndServiceIdRequest, getServiceCustomersByUserIdAndServiceIdSuccess = serviceCustomerActionCreators.getServiceCustomersByUserIdAndServiceIdSuccess, getServiceCustomersByUserIdAndServiceIdFail = serviceCustomerActionCreators.getServiceCustomersByUserIdAndServiceIdFail;
              dispatch(getServiceCustomersByUserIdAndServiceIdRequest());
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                serviceCustomers.getServiceCustomersByUserIdAndServiceId(userId, serviceId).then(function (serviceCustomer) {
                  dispatch(getServiceCustomersByUserIdAndServiceIdSuccess(serviceCustomer));
                  resolve(serviceCustomer);
                  return serviceCustomer;
                }, function (error) {
                  var message = getErrorMessageFromErrorResponse(error);
                  dispatch(getServiceCustomersByUserIdAndServiceIdFail(message));
                  reject(message);
                  handleErrorResponse(error, dispatch);
                });
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var clearServiceCustomerErrors = function clearServiceCustomerErrors() {
  return function (dispatch) {
    var clearServiceCustomerErrorsAction = serviceCustomerActionCreators.clearServiceCustomerErrorsAction;
    dispatch(clearServiceCustomerErrorsAction());
  };
};
export var setServiceCustomerInfo = function setServiceCustomerInfo(info) {
  return function (dispatch) {
    var setServiceCustomerInfoAction = serviceCustomerActionCreators.setServiceCustomerInfoAction;
    dispatch(setServiceCustomerInfoAction(info));
  };
};
export var clearServiceCustomerInfo = function clearServiceCustomerInfo() {
  return function (dispatch) {
    var clearServiceCustomerInfoAction = serviceCustomerActionCreators.clearServiceCustomerInfoAction;
    dispatch(clearServiceCustomerInfoAction());
  };
};